import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import RootAuth from "../../components/layouts/RootAuth";
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@nextui-org/react";
import { ArrowLeftIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { useForm } from "react-hook-form";
import logo from "../../assets/images/logo_klhk.png";
import { LOGIN_PATH } from "../../services/routes";
import { forgotPassword, registerFromPTSP } from "../../services/api";
import toast from "react-hot-toast";

export default function UserPTSPPage() {
    const [error, setError] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [userInfo, setUserInfo] = useState({ email: "", password: "" });
    const navigate = useNavigate();
    const [isOpenModalForm, setIsOpenModalForm] = useState(false);
    const { register, handleSubmit,reset, formState: { errors, isSubmitting }, } = useForm();
    // Handler untuk menutup modal form
    const closeModalForm = () => {
        setIsOpenModalForm(false);
        reset();
    };

    async function onSubmit(data) {
        setError("");
        const response = await registerFromPTSP(data);
        if (response.data?.success ) {
            // Simpan informasi email dan password ke state
            setUserInfo({ email: data.email, password: "Password123"});
            // Tampilkan modal
            setIsOpenModalForm(true);
        } else {
            toast.error(response?.data?.message);
        }
    }

    return (
        <RootAuth>
            <div className="relative w-full flex flex-col p-5 md:p-24 m-5 lg:m-0 bg-white shadow-md lg:shadow-none rounded-xl lg:rounded-none">
                <div className="text-center lg:text-start">
                    <img src={logo} alt="Logo" className="size-20 mx-auto lg:mx-0" />
                    <h3 className="font-bold text-2xl mt-5">Register User Dari PTSP</h3>
                    <p className="text-base">Masukan email yang sudah terdaftar di PTSP</p>
                </div>
                {error && <span className="text-danger">{error}</span>}
                <form className="pt-10 font-medium" onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        {...register('email', { required: "Email is required" })}
                        radius="sm"
                        className="pb-5"
                        type="email"
                        size="lg"
                        placeholder="Email"
                        startContent={<EnvelopeIcon className="size-5" />}
                        color={errors.email ? 'danger' : 'default'}
                        isInvalid={errors.email}
                        errorMessage={errors.email && errors.email.message}
                    />
                    <Button isLoading={isSubmitting} isDisabled={isSubmitting} type='submit' radius="sm" color="primary" size="lg" className="w-full">Register</Button>
                </form>
                <div className="mt-4 flex items-center gap-1 justify-center text-primary hover:underline">
                    <ArrowLeftIcon className="size-4" />
                    <Link to={LOGIN_PATH} className="">Kembali ke halaman login</Link>
                </div>
            </div>
             {/* Modal Form Tambah/Edit Tembusan */}
             <Modal isOpen={isOpenModalForm} onOpenChange={setIsOpenModalForm} onClose={closeModalForm}>
                    <ModalContent>
                        <ModalHeader>User Behasil Di Register dari PTSP (Silahkan Login Kembali)</ModalHeader>
                        <ModalBody>
                        <Input {...register('nama')} label="Email" isDisabled defaultValue={userInfo.email} />
                        <Input {...register('nama')} label="Password" isDisabled defaultValue={userInfo.password} />
                        <p className="mt-2 text-sm text-ink-500">Tolong segera update password setelah berhasil login.</p>   
                        </ModalBody>
                        <ModalFooter>
                            <Button onPress={closeModalForm} color="danger">Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
        </RootAuth>
    );
}
